import { scrollPageToReviews } from './scroll-page-to-reviews';

export function scrollToReviewsIfStarFilterIsSet(reviewListElement: HTMLElement) {
    if (isStarFilterSetInUrl()) {
        scrollPageToReviews(reviewListElement);
    }
}

function isStarFilterSetInUrl() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return !!urlSearchParams.get('filter');
}
